module.exports = __webpack_public_path__ + "img/favicon.384f7727.png";